import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { keyframes, css } from "@emotion/react";

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.text.disabled};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  ${(props) =>
    props.isActive
      ? css`
          background: linear-gradient(
            90deg,
            #607d8b 0%,
            #ffffff 25%,
            #9e9e9e 50%,
            #757575 75%,
            #607d8b 100%
          );
          background-size: 300% 100%;
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: ${gradientAnimation} 3s linear infinite;
        `
      : css`
          color: ${(p) => p.theme.text.disabled};
        `}
`;

const StatusBlock = ({ statusText, stepIndex, currentStepIndex }) => {
  const [isActive, setIsActive] = useState(false);

  const shouldBeActive = currentStepIndex === stepIndex;

  useEffect(() => {
    if (shouldBeActive && !isActive) {
      setIsActive(true);
    } else if (!shouldBeActive && isActive) {
      setIsActive(false);
    }
  }, [shouldBeActive, isActive, stepIndex]);

  if (!statusText) return null;

  return (
    <StatusContainer isActive={isActive}>
      <span>{statusText}</span>
    </StatusContainer>
  );
};

export default StatusBlock;
